export function startDownload(url: string) {
    const a: any = document.createElement('A');
    a.href = url;
    a.download = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}